// src/components/Eventos/EventsHeats/utils/eventHelpers.js
import { SPECIAL_CODES } from './constants';

// Función para verificar si un resultado es especial
export const isSpecial = (r) => {
  const track = SPECIAL_CODES.TRACK;
  const field = SPECIAL_CODES.FIELD;
  const isSpecialResult = track.includes(r) || field.includes(r);
  
  // Debugging temporal
  if (r && r !== '-') {
    console.log('[isSpecial] Verificando:', {
      value: r,
      type: typeof r,
      isSpecial: isSpecialResult,
      trackIncludes: track.includes(r),
      fieldIncludes: field.includes(r)
    });
  }
  
  return isSpecialResult;
};

// Función para obtener array seguro
export const safe = (a) => Array.isArray(a) ? a : [];

// Función para obtener colores de lugar (azul/turquesa alternado)
export const getPlaceColors = (place) => {
  const pos = +place;
  
  // Patrón alternado: azul para impares, turquesa para pares
  if (pos % 2 === 1) {
    // Impares (1, 3, 5, 7...) - Azul
    return {
      bg: '#1976d2',
      border: '#1565c0'
    };
  } else {
    // Pares (2, 4, 6, 8...) - Turquesa
    return {
      bg: '#00acc1',
      border: '#00838f'
    };
  }
};

// Función para verificar si un atleta tiene resultados válidos
export const hasValidResult = (row) => {
  console.log('[hasValidResult] Verificando atleta:', {
    id: row.number,
    name: row.name,
    place: row.place,
    timeRaw: row.timeRaw,
    result: row.result,
    isTrackEvent: row.isTrackEvent,
    attemptsData: row.attemptsData
  });
  
  // Verificar si tiene lugar válido (no '-' y es un número)
  if (row.place && row.place !== '-' && !isNaN(row.place)) {
    console.log('[hasValidResult] Tiene lugar válido:', row.place);
    return true;
  }
  
  // Verificar si tiene tiempo válido
  if (row.timeRaw && typeof row.timeRaw === 'number' && row.timeRaw > 0) {
    console.log('[hasValidResult] Tiene tiempo válido:', row.timeRaw);
    return true;
  }
  
  // Verificar si tiene resultado válido (incluyendo mejores marcas de campo)
  if (row.result && row.result !== '-' && !isSpecial(row.result)) {
    const numericResult = parseFloat(row.result);
    if (!isNaN(numericResult) && numericResult > 0) {
      console.log('[hasValidResult] Tiene resultado numérico válido:', row.result);
      return true;
    }
  }
  
  // Verificar si tiene marca especial válida (incluir TODOS los especiales excepto '-')
  if (row.result && row.result !== '-' && isSpecial(row.result)) {
    console.log('[hasValidResult] Tiene marca especial válida:', row.result);
    return true;
  }
  
  // CORREGIDO: Para eventos de campo, incluir atletas que tienen CUALQUIER intento registrado
  if (!row.isTrackEvent && row.attemptsData && row.attemptsData.length > 0) {
    // Contar intentos que tienen algún resultado registrado (incluye fauls 'X')
    const hasAnyAttempt = row.attemptsData.some(attempt => 
      attempt && 
      attempt.result !== undefined && 
      attempt.result !== null && 
      attempt.result !== '' && 
      attempt.result !== '-'
    );
    
    if (hasAnyAttempt) {
      console.log('[hasValidResult] Tiene intentos registrados en campo (incluye fauls)');
      return true;
    }
  }
  
  console.log('[hasValidResult] NO tiene resultados válidos');
  return false;
};

// Función para verificar si las filas se pueden ordenar por lugar
export const sortByPlace = (rows) =>
  rows.some(r => r.place && r.place !== '-' && !isNaN(r.place));

// Función para obtener color de código especial
export const getSpecialCodeColor = (code, theme) => {
  switch(code) {
    case 'DNS':
    case 'DNF':
    case 'DQ':
    case 'NM':
      return '#f44336';
    case 'q':
    case 'Q':
    case 'qR':
    case 'qJ':
    case 'qD':
      return '#4caf50';
    case 'YC':
    case 'YRC':
      return '#ffeb3b';
    case 'RC':
      return '#f44336';
    default:
      return theme.palette.text.primary;
  }
};

// Función responsiva para obtener tamaño de fuente
export const getFontSize = (base, mult = 1, isXs, isSm, isMd) => {
  if (isXs) return `${base * 0.75 * mult}px`;
  if (isSm) return `${base * 0.85 * mult}px`;
  if (isMd) return `${base * 0.95 * mult}px`;
  return `${base * mult}px`;
};